/**
 * A due day as the student reads it (pedagogy spec §3.3.5 items 3 and 6): "tors 25 sep", or "idag"
 * for today and anything overdue (the server keeps an overdue day as it is, and Today serves it
 * as a re-test now).
 */
import { useLang, useT } from "@client/i18n";
import { formatDayShort } from "@client/lib/format";
import { DEFAULT_TIMEZONE, dayKey } from "@shared/time";

/** `today` is a day key; it defaults to the clock in the app timezone (tests pass one). */
export function useDayLabel(today?: string): (day: string) => string {
  const t = useT();
  const { lang } = useLang();
  const base = today ?? dayKey(Date.now(), DEFAULT_TIMEZONE);
  // Day keys are zero-padded `YYYY-MM-DD`, so the string order is the calendar order.
  return (day) => (day <= base ? t("progress.comingBack.today") : formatDayShort(day, lang));
}
